import React, { useEffect, useState } from 'react';
import { X, ArrowRight } from 'lucide-react';
export const FloatingActionBar = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  useEffect(() => {
    // Delay appearance slightly for better UX
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  if (isClosed) return null;
  return <div className={`fixed bottom-0 left-0 right-0 z-50 transition-transform duration-500 ease-in-out ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-2158" data-mp="1togg24alv7fl">
      <div className="bg-white border-t border-gray-200 shadow-[0_-8px_30px_rgba(0,0,0,0.12)]" data-id="element-2159" data-mp="1jsmujvews3lo">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2160" data-mp="1opwpfql2h7gw">
          <div className="flex flex-col sm:flex-row items-center justify-between py-3 sm:py-0 gap-3 sm:gap-0" data-id="element-2161" data-mp="1aqx2qoh472nd">
            {/* Left Section: Offer Badge */}
            <div className="relative flex-shrink-0 mt-[-20px] sm:mt-[-24px] mb-2 sm:mb-4 self-start sm:self-auto ml-2 sm:ml-0" data-id="element-2162" data-mp="1fpgsz12qr0lj">
              <div className="bg-[#00CCFF] text-black font-bold text-xl px-4 py-3 shadow-lg transform -rotate-2 rounded-sm flex items-center justify-center min-w-[100px]" data-id="element-2163" data-mp="mxgdyh14le1m">
                $5 OFF
              </div>
              {/* Close Icon overlapping top-right */}
              <button onClick={() => setIsClosed(true)} className="absolute -top-3 -right-3 bg-white text-gray-500 hover:text-gray-900 rounded-full p-1 shadow-md border border-gray-100 transition-colors" aria-label="Close offer" data-id="element-2164" data-mp="rv81yzyngg0j">
                <X size={14} strokeWidth={2.5} data-id="element-2165" data-mp="dwi61nnkgmdr" />
              </button>
            </div>

            {/* Right Section: Content & CTA */}
            <div className="flex-1 flex flex-col sm:flex-row items-center justify-between sm:ml-8 w-full sm:w-auto pb-3 sm:pb-0" data-id="element-2166" data-mp="92e0n8ty8mes">
              <div className="text-center sm:text-left mb-3 sm:mb-0" data-id="element-2167" data-mp="3clpd6q0ry3kk">
                <p className="text-gray-900 font-semibold text-base sm:text-lg" data-id="element-2168" data-mp="1ghsrq3zptxmd">
                  Unlock your full relationship analysis
                </p>
                <p className="text-gray-500 text-xs sm:text-sm hidden sm:block" data-id="element-2169" data-mp="1lfb1fwlk4gvf">
                  Limited time offer for new users
                </p>
              </div>

              <div className="flex items-center gap-4 sm:py-4" data-id="element-2170" data-mp="1u9fpk89b3e79">
                <a href="/signup" className="group bg-gray-900 hover:bg-black text-white px-6 py-2.5 rounded-full font-semibold text-sm transition-all shadow-md hover:shadow-lg flex items-center gap-2" data-id="element-2171" data-mp="xiwxisnuxj8j">
                  Claim Offer
                  <ArrowRight size={16} className="group-hover:translate-x-0.5 transition-transform" data-id="element-2172" data-mp="16lpn8rhe5mw9" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};